import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Card = ({ children, title, onClick, disabled, className }) => {
    return (
        <div className={clsx("card", { disabled }, className)} onClick={disabled ? undefined : onClick}>
            {title && (
                <div className="card__header">
                    <div className="card__title">{title}</div>
                </div>
            )}
            <div className="card__body">{children}</div>
        </div>
    );
};

Card.propTypes = {
    children: PropTypes.node,
    title: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
};

Card.defaultProps = {
    children: "",
    title: "",
    onClick: () => {},
    disabled: false,
    className: undefined,
};

export default Card;
